module.exports = ".marca{\n\n}\n.marca select.form-control {\n    max-width: calc(100% - 0px);\n}\n.foto-marca{}\n"